import { z } from 'zod';

export const appEnvSchema = z
  .object({
    VITE_SENTRY_ENABLED: z.string().optional(),
    VITE_BACKEND_URL: z.string().url(),
    VITE_SENTRY_DSN: z.string().url().optional(),
    VITE_SENTRY_SAMPLE_RATE: z.coerce
      .number()
      .min(0, 'VITE_SENTRY_SAMPLE_RATE must be >= 0')
      .max(1, 'VITE_SENTRY_SAMPLE_RATE must be <= 1')
      .optional(),
    VITE_HITPHONE_DESKTOP_URL: z.string().url(),
    VITE_OMNIHIT_BASE_AUTH_URL: z.string().url(),
  })
  .superRefine((data, ctx) => {
    if (data.VITE_SENTRY_ENABLED === 'true') {
      if (!data.VITE_SENTRY_DSN) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['VITE_SENTRY_DSN'],
          message:
            'VITE_SENTRY_DSN is required when VITE_SENTRY_ENABLED is true',
        });
      }
      if (!data.VITE_SENTRY_SAMPLE_RATE) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['VITE_SENTRY_SAMPLE_RATE'],
          message:
            'VITE_SENTRY_SAMPLE_RATE is required when VITE_SENTRY_ENABLED is true',
        });
      }
    }
  });

export const viteEnvSchema = z
  .object({
    VITE_SENTRY_ENABLED: z.string().optional(),
    SENTRY_ORG: z.string().optional(),
    SENTRY_PROJECT: z.string().optional(),
    SENTRY_AUTH_TOKEN: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.VITE_SENTRY_ENABLED === 'true') {
      if (!data.SENTRY_ORG) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['SENTRY_ORG'],
          message: 'SENTRY_ORG is required when VITE_SENTRY_ENABLED is true',
        });
      }
      if (!data.SENTRY_PROJECT) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['SENTRY_PROJECT'],
          message:
            'SENTRY_PROJECT is required when VITE_SENTRY_ENABLED is true',
        });
      }
      if (!data.SENTRY_AUTH_TOKEN) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['SENTRY_AUTH_TOKEN'],
          message:
            'SENTRY_AUTH_TOKEN is required when VITE_SENTRY_ENABLED is true',
        });
      }
    }
  });
